// src/components/dialogs/DeleteDialog.tsx
import { useTranslation } from "react-i18next";

import { ActionButton } from "@/components/common";
import {
    Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui";

interface DeleteDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    title: string;
    description: string;
    onConfirm: () => void;
}

export function DeleteDialog({
    open,
    onOpenChange,
    title,
    description,
    onConfirm,
}: DeleteDialogProps) {
    const { t } = useTranslation();

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription>
                        {description}
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter className="gap-2">
                    <ActionButton
                        label={t("action.cancel")}
                        variant="outline"
                        onClick={() => onOpenChange(false)}
                    />
                    <ActionButton
                        label={t("action.delete")}
                        variant="destructive"
                        onClick={onConfirm}
                    />
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
} 